import { ComponentPropsWithoutRef } from "react";
import { FormControl } from "react-bootstrap";
import { useBlockType } from "../../contexts/BlockTypeContext";

type Props = ComponentPropsWithoutRef<typeof FormControl>;

/**
 * bootstrap hoc to change single line text input to simple div when is not editable
 */
const CustomReadonlyInput = ({
  value,
  className,
  children,
  ...rest
}: Props) => {
  const { isEdit } = useBlockType();

  return (
    <FormControl
      className={className}
      {...(isEdit
        ? {
            type: "text",
            value: value || "",
            ...rest,
          }
        : {
            as: "div",
            children: (
              <>
                <span>{value || ""}</span>
                {children}
              </>
            ),
          })}
    />
  );
};

export default CustomReadonlyInput;
